<crowdctrl-page
  [pageTitle]="(pageTitle$ | async) ?? 'Welcome'"
  [contentClass]="'home-page-content'"
>
  <div class="home-header">
    <h1>{{ appName }}</h1>
    <p class="home-subtitle">{{ appSubtitle }}</p>
  </div>

  <div class="dashboard-tiles">
    <a
      href="/workspaces/select"
      class="service-tile"
      [class.disabled]="isNavigating"
      [class.selected]="selectedTilePath === '/workspaces/select'"
      (click)="navigateTo('/workspaces/select', $event)"
    >
      @if (selectedTilePath === '/workspaces/select') {
        <ion-spinner name="crescent" class="tile-icon"></ion-spinner>
      } @else {
        <ion-icon name="grid-outline" class="tile-icon"></ion-icon>
      }
      <span class="tile-label">Boards</span>
    </a>
    <a
      href="/settings"
      class="service-tile"
      [class.disabled]="isNavigating"
      [class.selected]="selectedTilePath === '/settings'"
      (click)="navigateTo('/settings', $event)"
    >
      @if (selectedTilePath === '/settings') {
        <ion-spinner name="crescent" class="tile-icon"></ion-spinner>
      } @else {
        <ion-icon name="settings-outline" class="tile-icon"></ion-icon>
      }
      <span class="tile-label">Settings</span>
    </a>
    <button
      type="button"
      class="service-tile"
      [class.disabled]="isNavigating"
      [class.selected]="selectedTilePath === 'signout'"
      (click)="signOutFromTile($event)"
    >
      @if (selectedTilePath === 'signout') {
        <ion-spinner name="crescent" class="tile-icon"></ion-spinner>
      } @else {
        <ion-icon name="log-out-outline" class="tile-icon"></ion-icon>
      }
      <span class="tile-label">Sign out</span>
    </button>
  </div>
</crowdctrl-page>
